import { render, staticRenderFns } from "./my-product.vue?vue&type=template&id=4ab7b4aa&scoped=true&"
import script from "./my-product.vue?vue&type=script&lang=js&"
export * from "./my-product.vue?vue&type=script&lang=js&"
import style0 from "./my-product.vue?vue&type=style&index=0&id=4ab7b4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7b4aa",
  null
  
)

export default component.exports